import api from '@pray/shared/utils/api';

export async function getPrayRadioDailyItem({
  artistId,
  dailySeriesId,
  dailyItemId,
}: {
  artistId: string;
  dailySeriesId: string;
  dailyItemId: string;
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!dailySeriesId) throw Error('Daily Series ID is required');
  if (!dailyItemId) throw Error('Daily Item ID is required');

  const url = `/web/studio/artists/${artistId}/daily-series/${dailySeriesId}/daily-items/${dailyItemId}/pray-radio-content`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
